<template>
  <div v-if="!zipcodeCache && !generating">
    <span class="cache-text">Der Cache für dynamische PLZ fehlt</span>
    <button class="btn btn-secondary" @click="generateZipcodeCache">
      Jetzt generieren
    </button>
  </div>
</template>

<script>
import { bus } from "@/bus";

export default {
  name: "zipcode-cache-warning",
  data() {
    return {
      generating: true
    };
  },
  created() {
    this.generating = Laravel.is_generating_zipcode;
    bus.$on("background-task-update", data => {
      if (data.name == "calculate-zipcode-cache") {
        this.generating = true;
      }
    });
  },
  computed: {
    zipcodeCache() {
      return Laravel.zipcode_cache;
    }
  },
  methods: {
    generateZipcodeCache() {
      this.generating = true;
      this.$http
        .post("/api/v1/admin-actions/generate-zipcode-cache")
        .then(() => {
          this.$notify({
            title: `Der PLZ-Cache wird generiert`,
            type: "success"
          });
        });
    }
  }
};
</script>

<style scoped>
.cache-text {
  margin-left: 30px;
  margin-right: 20px;
  font-size: 16px;
}
</style>
